<div class="button-container">
	<button class="fm-btn fm-btn--brand-yellow" (click)="open()">
		Contact us
	</button>
</div>
